import * as React from 'react';
import { Form } from '../index';
import clsx from 'clsx';
type NativeProps = React.ComponentProps<typeof Form.Check>;
export type SwitchProps = Pick<
  NativeProps,
  | 'onChange'
  | 'name'
  | 'label'
  | 'isInvalid'
  | 'checked'
  | 'disabled'
  | 'defaultChecked'
> & {
  id: string;
  size?: 'sm' | 'md' | 'lg';
  indeterminate?: boolean;
};
const Switch: React.FC<SwitchProps> = ({
  size = 'sm',
  indeterminate,
  ...props
}) => {
  const switchRef = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    if (switchRef.current) {
      switchRef.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate]);

  return (
    <Form.Check
      ref={switchRef}
      {...props}
      className={clsx('d-flex', size)}
      id={props.id || props.name}
      data-cy={props.name}
      onClick={(e) => {
        e.stopPropagation();
      }}
      type='switch'
    />
  );
};

export default Switch;
